import { CategoryApi } from "@/services/collection/categories";
import { type ArticleWidget, ArticleWidgetType } from "@/services/articles";
import { fetchCollectibleById } from "@/services/collectibles";

export function useWidgets(startingHtml: string, uuid: number) {
  const widgets: ArticleWidget[] = [];
  const html = ref<string>(startingHtml);

  async function parseWidgets() {
    const regex = createPlaceholderRegex();
    const matches = [...html.value.matchAll(regex)];

    return await Promise.all(
      matches.map(async (match, i) => {
        const jsonString = match[0];
        const data = JSON.parse(jsonString);

        const categoryId = Number(data.categoryId);
        const category = await CategoryApi.fetchById(categoryId);
        const itemId = parseInt(data.itemId); // We can use parseInt because regex matches string consisted only of numbers.
        const triggerElementIdentification = createTriggerIdentification(i);
        const widget: ArticleWidget = {
          type: data.type,
          triggerElementIdentification,
          params: {
            category,
            label: data.label,
            item: await fetchCollectibleById(itemId),
            price: String(data.price),
            date: data.date,
          },
        };

        const labelPlaceholder = `<span data-widget="${triggerElementIdentification}"></span>`;
        html.value = html.value.replace(jsonString, labelPlaceholder);
        widgets.push(widget);
      })
    );
  }

  const createTriggerIdentification = (widgetIndex: number): string => uuid + "_" + widgetIndex;

  return {
    parseWidgets,
    html,
    widgets,
  };
}

const createPlaceholderRegex = (): RegExp => new RegExp('{"widget":"' + ArticleWidgetType.DatabaseItem + '",.*?}', "g");
